import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UserStateService } from 'src/app/auth/services/user-state.service';
import { CompanyStateService } from 'src/app/auth/services/company-state.service';
import { AIChatbotMessage } from '../../models/ai-chatbot-message';
import { AIChatbotBaseLoggingService } from '../ai-chatbot-base-logging/ai-chatbot-base-logging.service';

@Injectable({
  providedIn: 'root',
})
export class AIChatbotFeedbackLoggingService extends AIChatbotBaseLoggingService {
  constructor(
    http: HttpClient,
    userStateService: UserStateService,
    companyStateService: CompanyStateService,
  ) {
    super(http, userStateService, companyStateService);
  }

  /**
   * Logs feedback to BigQuery chats_feedback table
   * @param sessionId - The chat session ID
   * @param messageIdx - The index of the message in the conversation
   * @param message - The message object that received feedback
   * @param feedbackRating - 'good' or 'bad'
   * @param feedbackMessage - Optional feedback message text
   */
  logFeedback(
    sessionId: string,
    messageIdx: number,
    message: AIChatbotMessage,
    feedbackRating: 'good' | 'bad',
    feedbackMessage?: string,
  ): Observable<any> {
    const commonFields = this.buildCommonFields();
    const jsonData = {
      ...commonFields,
      session_id: sessionId,
      message_idx: messageIdx,
      feedback_rating: feedbackRating,
      feedback_message: feedbackMessage || null,
    };

    return this.insertData(this.getTableUrl('chats_feedback'), jsonData);
  }
}
